// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { HorizontalOrVertical } from '../tbs/horizontal-or-vertical.js';
import { Position, PositionT } from '../tbs/position.js';


export class RownipulatorDuplicateRowAction implements flatbuffers.IUnpackableObject<RownipulatorDuplicateRowActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):RownipulatorDuplicateRowAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsRownipulatorDuplicateRowAction(bb:flatbuffers.ByteBuffer, obj?:RownipulatorDuplicateRowAction):RownipulatorDuplicateRowAction {
  return (obj || new RownipulatorDuplicateRowAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsRownipulatorDuplicateRowAction(bb:flatbuffers.ByteBuffer, obj?:RownipulatorDuplicateRowAction):RownipulatorDuplicateRowAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new RownipulatorDuplicateRowAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapRownipulatorDuplicateRow;
}

position(obj?:Position):Position|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new Position()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

orientation():HorizontalOrVertical {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : HorizontalOrVertical.Horizontal;
}

static startRownipulatorDuplicateRowAction(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapRownipulatorDuplicateRow);
}

static addPosition(builder:flatbuffers.Builder, positionOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, positionOffset, 0);
}

static addOrientation(builder:flatbuffers.Builder, orientation:HorizontalOrVertical) {
  builder.addFieldInt8(2, orientation, HorizontalOrVertical.Horizontal);
}

static endRownipulatorDuplicateRowAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): RownipulatorDuplicateRowActionT {
  return new RownipulatorDuplicateRowActionT(
    this.type(),
    (this.position() !== null ? this.position()!.unpack() : null),
    this.orientation()
  );
}


unpackTo(_o: RownipulatorDuplicateRowActionT): void {
  _o.type = this.type();
  _o.position = (this.position() !== null ? this.position()!.unpack() : null);
  _o.orientation = this.orientation();
}
}

export class RownipulatorDuplicateRowActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapRownipulatorDuplicateRow,
  public position: PositionT|null = null,
  public orientation: HorizontalOrVertical = HorizontalOrVertical.Horizontal
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const position = (this.position !== null ? this.position!.pack(builder) : 0);

  RownipulatorDuplicateRowAction.startRownipulatorDuplicateRowAction(builder);
  RownipulatorDuplicateRowAction.addType(builder, this.type);
  RownipulatorDuplicateRowAction.addPosition(builder, position);
  RownipulatorDuplicateRowAction.addOrientation(builder, this.orientation);

  return RownipulatorDuplicateRowAction.endRownipulatorDuplicateRowAction(builder);
}
}
